import React from "react"
import { FormattedMessage } from "react-intl"
import Modal from "react-modal"
import unauthorized from "../../../../assets/images/unauthorized.svg"
import "./index.css"

Modal.setAppElement(document.getElementById("root") as HTMLElement)

interface ForbiddenModalProps {
	isOpen: boolean
	onClose: () => void
}

const ForbiddenModal: React.FC<ForbiddenModalProps> = ({ isOpen, onClose }) => {
	const closeModal = () => {
		onClose()
	}

	return (
		<div>
			<Modal id="modal-forbidden" isOpen={isOpen}>
				<div className="forbidden-modal-container">
					<div className="content">
						<div className="alert-title">
							<span>
								<FormattedMessage
									id={"phronesis.modal.forbidden.title"}
									defaultMessage="We are sorry"
								/>
							</span>
						</div>
						<div className="alert-description">
							<span>
								<FormattedMessage
									id={"phronesis.modal.forbidden.description"}
									defaultMessage="You don’t have permissions to access this platform."
								/>
							</span>
						</div>
					</div>
					<div className="image">
						<img alt="error-image" className="error-image" src={unauthorized} />
					</div>
					<div className="close-button">
						<button
							id="close-modal"
							className="action-button"
							onClick={closeModal}
						>
							<FormattedMessage
								id="phronesis.modal.button.ok"
								defaultMessage="Ok"
							/>
						</button>
					</div>
				</div>
			</Modal>
		</div>
	)
}

export default ForbiddenModal
